__turbopack_context__.v({
  "radio": "collapsible-purchase-section-module-scss-module__pkPkLa__radio",
  "radio-controlled-content": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-content",
  "radio-controlled-title": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-title",
  "radio-controlled-title-wrapper": "collapsible-purchase-section-module-scss-module__pkPkLa__radio-controlled-title-wrapper",
  "uncontrolled-container": "collapsible-purchase-section-module-scss-module__pkPkLa__uncontrolled-container",
  "uncontrolled-content-wrapper": "collapsible-purchase-section-module-scss-module__pkPkLa__uncontrolled-content-wrapper",
});
